export function stringifyAttributes(attributes: Record<string, string>) {
    return Object.entries(attributes)
      .sort(([aKey], [bKey]) => aKey.localeCompare(bKey))
      .map(([key, value]) => `${key}:${value}`)
      .join("|");
  }